import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, styled } from '@mui/material';
import { getShopifyID } from '../../utils/utils';
import { QuantitySelector } from '../shared/QuantitySelector';
import { Product } from '../../models/Product';
import { CollectionProductTitle } from './CollectionProductItem/CollectionProductTitle';
import { CollectionProductStockStatus } from './CollectionProductItem/CollectionProductStockStatus';
import { CollectionProductNetPrice } from './CollectionProductItem/CollectionProductNetPrice';
import { CollectionProductAddToQuotation } from './CollectionProductItem/CollectionProductAddToQuotation';
import { CollectionProductImage } from './CollectionProductItem/CollectionProductImage';
import { ProductStockLocation } from '../../models/ProductStock';

const StyledImage = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    img: {
        maxWidth: '100%',
    },
}));

const StyledWrapper = styled(Box)(() => ({
    border: '1px solid #f5f5f5',
    borderRadius: '5px',
    height: '100%',
    padding: '10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: '20px',
}));

const StyledCardFooter = styled(Box)(() => ({
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
}));

const StyledCardContent = styled(Box)(() => ({
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
    ' > *': {
        flex: '1',
    },
}));

export const CollectionGridProductItem = (props: ProductProps) => {
    const { t } = useTranslation('collection');
    const { product, productQuantity, handle } = props;
    const variant = product.variants.nodes[0];
    const [qty, setQty] = useState(1);

    const handleChange = (qty) => {
        setQty(qty);
    };

    if (product.customPrices) {
        variant.price.amount = product.customPrices.prices.find(
            (elem) => elem.variantId == getShopifyID(variant.id)
        ).price;
    }

    return (
        <StyledWrapper>
            <StyledImage>
                <CollectionProductImage product={product} />
            </StyledImage>
            <Box>
                <Box sx={{ justifyContent: 'center' }}>
                    <CollectionProductTitle
                        product={product}
                        collectionHandle={handle}
                        variantSku={variant.sku}
                    />
                </Box>
                <StyledCardContent>
                    <CollectionProductStockStatus quantity={productQuantity} />
                    <CollectionProductNetPrice variant={variant} />
                </StyledCardContent>
                <StyledCardFooter>
                    <Box>
                        <QuantitySelector
                            variant={variant}
                            qtyChanged={handleChange}
                        />
                    </Box>
                    <CollectionProductAddToQuotation
                        variant={variant}
                        quantity={qty}
                    />
                </StyledCardFooter>
            </Box>
        </StyledWrapper>
    );
};

type ProductProps = {
    product: Product;
    productQuantity: ProductStockLocation;
    handle: string;
};
